import React from 'react';
import { Grid } from '@mui/material';
import { Person } from '../../types';
import { PersonCard } from '../person/PersonCard';

/**
 * PeopleGrid Component
 *
 * Displays people in a grid layout
 *
 * Features:
 * - Uses existing PersonCard component with variant="full"
 * - Responsive grid: 3-4 columns desktop, 1-2 mobile
 * - Click card to navigate to profile
 *
 * @component
 * @param {PeopleGridProps} props - Component props
 * @returns {JSX.Element} Grid view of people
 */
interface PeopleGridProps {
  persons: Person[];
  onPersonClick: (personId: string) => void;
}

export const PeopleGrid: React.FC<PeopleGridProps> = ({
  persons,
  onPersonClick,
}) => {
  // ===== Event Handlers =====
  const handlePersonView = (person: Person | import('../../types').PersonSummary) => {
    onPersonClick(person.id);
  };

  // ===== Render =====
  return (
    <Grid container spacing={3}>
      {persons.map((person) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          key={person.id}
        >
          <PersonCard
            person={person}
            variant="full"
            showActions={false}
            onView={handlePersonView}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default PeopleGrid;
